import { render, staticRenderFns } from "./WangEdit.vue?vue&type=template&id=42bf760b"
import script from "./WangEdit.vue?vue&type=script&lang=js"
export * from "./WangEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports